// pages/integrations/PipelineConfigPage.jsx — SOUND-709
//
// Pipeline Config as its own page under the Settings rail, rather than a tab on
// the credentials route.
//
// WHY IT MOVED. It was the last non-credential tenant of /integrations. Store
// IDs, lookback hours and schedules are CONFIGURATION, not secrets — the
// confusion between the two is exactly what produced
// `phoenix: ["apiKey", "storeIds"]` in the old PROVIDER_PRESETS map, treating a
// store list as a credential field. SOUND-681 moved Rerunner and Billing out of
// this section for the same reason; this follows them.
//
// EXPECTED TO MOVE AGAIN — managed-services onboarding, or Track B self-serve
// connect (SOUND-663), will want a client-reachable version. Internal-only
// until one of those lands.
import React from "react";
import PageHeader from "components/PageLayout";
import PipelineConfigTab from "./PipelineConfigTab";

export default function PipelineConfigPage() {
  return (
    <>
      <PageHeader
        title="Pipeline Config"
        subtitle="Data pipeline configuration — schedules, lookback windows, and per-client settings."
      />
      <div className="px-6 pb-10">
        <PipelineConfigTab />
      </div>
    </>
  );
}
